import axios from 'axios';

export default axios.create({
  baseURL: 'https://pivotal-keep-324902.rj.r.appspot.com',
  // baseURL: 'http://localhost:3333',
});
